import React, { useState } from 'react';
import { Tabs, Tab } from "@material-ui/core";
import MidiaOticas from "../../pages/midia-oticas/midia-oticas";
import Carrossel from "../../pages/carrossel/carrossel";

const MidiaLabsList = ({ selectedLab, hasUploadPermission, permissionLoaded, onBack, isLabUser }) => {
	const [activeTab, setActiveTab] = useState(0);

	const handleTabChange = (event, newValue) => {
		setActiveTab(newValue);
	};

	if (!permissionLoaded) return null;

	return (
		<div className="midia-labs-list">
			<Tabs
				value={activeTab}
				onChange={handleTabChange}
				className="midia-labs-tabs"
				id="midia-labs-tabs">
				<Tab label="Mídias para Óticas" className="midia-labs-tab" id="midia-labs-tab-midias" />
				{hasUploadPermission && <Tab label="Carrossel" className="midia-labs-tab" id="midia-labs-tab-carrossel" />}
			</Tabs>

			<div style={{ display: activeTab === 0 ? 'block' : 'none' }}>
				<MidiaOticas
					selectedLab={selectedLab}
					hasUploadPermission={hasUploadPermission}
					isLabUser={isLabUser}
					isActive={activeTab === 0}
				/>
			</div>

			{hasUploadPermission && (
				<div style={{ display: activeTab === 1 ? 'block' : 'none' }}>
					<Carrossel
						selectedLab={selectedLab}
						hasUploadPermission={hasUploadPermission}
						isLabUser={isLabUser}
						isActive={activeTab === 1}
					/>
				</div>
			)}
		</div>
	);
};

export default MidiaLabsList;
